const METHOD_LABELS = {
  stripe: "Card payment",
  cash: "Cash",
  zelle: "Zelle",
  cashapp: "Cash App",
};

function getMethodLabel(method) {
  return METHOD_LABELS[method] || method.charAt(0).toUpperCase() + method.slice(1);
}

function PaymentMethodSelector({ paymentOptions, selectedMethod, onChange }) {
  const methods = paymentOptions?.payment_methods || {};
  const enabledMethods = Object.entries(methods).filter(([, config]) => config.enabled);
  const onlyCardPaymentEnabled = enabledMethods.length === 1 && enabledMethods[0][0] === "stripe";

  if (onlyCardPaymentEnabled) {
    return null;
  }

  return (
    <div className="payment-method-list" role="radiogroup" aria-label="Payment method">
      {enabledMethods.map(([method, config]) => (
        <label className="payment-method-option" key={method}>
          <input
            checked={selectedMethod === method}
            name="payment_method"
            onChange={() => onChange(method)}
            type="radio"
            value={method}
          />
          <span>
            <strong>{getMethodLabel(method)}</strong>
            {config.instructions ? <small>{config.instructions}</small> : null}
            {config.recipient_email ? <small>{config.recipient_email}</small> : null}
            {config.cashtag ? <small>{config.cashtag}</small> : null}
          </span>
        </label>
      ))}
    </div>
  );
}

export default PaymentMethodSelector;
